import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { UX2 } from '@wsb/guac-widget-core';
import { TWITTER_URL, FACEBOOK_URL } from '../../../constants/SocialShare';
import { RouteHandler } from '@wsb/guac-widget-shared/lib/common/ols-core/core-bundle';
import { ProductDetailStore } from '@wsb/guac-widget-shared/lib/common/ols-core/shop-bundle';
import ShopView from '@wsb/guac-widget-shared/lib/common/ols-core/constants/ShopView';
import * as Metrics from '../../utils/trackMetric';
import * as MetricEvents from '../../../../constants/metrics';
import dataAids from '../../../../constants/dataAids';

function SocialSharing({
  showFacebook,
  showTwitter,
  domainName,
  translate = () => {},
  renderMode
}) {
  const isPublishMode = renderMode === 'PUBLISH';
  const { Block, Icon, Text } = UX2.Element;
  const showSocialShareIcons = showFacebook || showTwitter;
  useEffect(() => {
    if (showSocialShareIcons && isPublishMode) {
      Metrics.track(MetricEvents.SOCIAL_SHARING_C2_IMPRESSION);
    }
  }, []);

  const createDeepLink = () => {
    const productDetails = ProductDetailStore.getState();
    const params = {
      slug: productDetails.product.slug,
      selectedVariantSku: productDetails.selectedVariantSku
    };
    const protocol = typeof window !== 'undefined' ? window.location.protocol : 'https:';
    const siteUrl = `${protocol}//${domainName}`;

    return `${siteUrl}${RouteHandler.generateUrl(ShopView.PRODUCT_DETAIL, params)}`;
  };
  const handleTwitterOnClick = () => {
    if (isPublishMode) {
      Metrics.track(MetricEvents.SOCIAL_SHARING_TWITTER_CTA_CLICK);
      const deepLink = createDeepLink();
      window.location.replace(`${TWITTER_URL}${deepLink}`);
      window.history.pushState({}, null, window.location.href);
    }
  };

  const handleFacebookOnClick = () => {
    if (isPublishMode) {
      Metrics.track(MetricEvents.SOCIAL_SHARING_FACEBOOK_CTA_CLICK);
      const deepLink = createDeepLink();
      window.open(`${FACEBOOK_URL}${deepLink}`, 'facebook-share-dialog', 'width=510, height=424');
    }
  };

  const styles = {
    outerContainer: {
      marginBottom: 'small',
      display: 'inline-flex',
      alignItems: 'center'
    },
    wrapper: {
      display: 'flex',
      cursor: isPublishMode ? 'pointer' : 'not-allowed',
      marginLeft: 'xxsmall'
    }
  };

  if (!showSocialShareIcons) {
    return null;
  }

  return (
    <Text style={ styles.outerContainer } data-aid={ dataAids.SOCIAL_SHARING_WRAPPER }>
      <Text featured children={ translate('products.share') + ':' } />
      <Text featured style={ styles.wrapper }>
        { showFacebook && (
          <Block onClick={ handleFacebookOnClick } data-aid={ dataAids.SOCIAL_SHARING_FACEBOOK_ICON }>
            <Icon icon='facebook' size='30' />
          </Block>
        ) }
        { showTwitter && (
          <Block onClick={ handleTwitterOnClick } data-aid={ dataAids.SOCIAL_SHARING_TWITTER_ICON }>
            <Icon icon='twitter' size='30' />
          </Block>
        ) }
      </Text>
    </Text>
  );
}

SocialSharing.propTypes = {
  showFacebook: PropTypes.bool,
  showTwitter: PropTypes.bool,
  domainName: PropTypes.string,
  renderMode: PropTypes.string,
  translate: PropTypes.func
};

export default SocialSharing;
